import { Injectable } from '@angular/core';
import { GenericResponse } from '../business-entities/generic-response';
import { Urls } from './../../../../Autofacets-Core/src/app/utils/urls';
import { DataService } from './../../../../Autofacets-Core/src/app/services/data.service'
import { TimeCodeResponseModel } from '../business-entities/time-code-response.model';
import { DwoMechanicTimeCodeResponseModel } from '../business-entities/dwo-mechanic-time-code-response.model';
import { StampInOutRequestModel } from '../business-entities/stamp-in-out-request.model';
import { MechanicTimeCodeTimerRequestModel } from '../business-entities/mechanic-time-code-timer-request.model';
import { MechanicWorkOrderTimerRequestModel } from '../business-entities/mechanic-work-order-timer-request.model';
import { MechanicJobTimerRequestModel } from '../business-entities/mechanic-job-timer-request.model';
import { JobsByWOResponseModel } from '../business-entities/jobs-by-work-order.response.model';
import { WorkOrderModel } from '../business-entities/work-order-model';


@Injectable({
    providedIn: 'root'
})

export class MechanicTimeStampDataService {
    constructor(private dataProvider: DataService) {
    }



    async GetSummaryDetails(id: number, date: Date): Promise<GenericResponse<Array<TimeCodeResponseModel>>> {
        const model = {
            mechanicId: id,
            date: date.toDateString()
        }
        return this.dataProvider.GetAllwithHeaders<GenericResponse<Array<TimeCodeResponseModel>>>(Urls.GetSummaryDetails, model).toPromise();
    }

    async GetMechanicTimeCodes(dealerId: string, langCode: string): Promise<GenericResponse<Array<DwoMechanicTimeCodeResponseModel>>> {
        return this.dataProvider.Get<GenericResponse<Array<DwoMechanicTimeCodeResponseModel>>>(Urls.GetMechanicTimeCodes, dealerId, langCode).toPromise();
    }

    async MechanicStampIn(model: StampInOutRequestModel): Promise<GenericResponse<boolean>> {
        return this.dataProvider.Post<GenericResponse<any>>(Urls.MechanicStampIn, model).toPromise();
    }

    async MechanicStampOut(model: StampInOutRequestModel): Promise<GenericResponse<boolean>> {
        return this.dataProvider.Post<GenericResponse<any>>(Urls.MechanicStampOut, model).toPromise();
    }

    async StopTimeCodeTimer(model: MechanicTimeCodeTimerRequestModel): Promise<GenericResponse<boolean>> {
        return this.dataProvider.Post<GenericResponse<any>>(Urls.StopTimeCodeTimer, model).toPromise();
    }

    async StartTimeCodeTimer(model: MechanicTimeCodeTimerRequestModel): Promise<GenericResponse<boolean>> {
        return this.dataProvider.Post<GenericResponse<any>>(Urls.StartTimeCodeTimer, model).toPromise();
    }

    async GetTimeCodeDetails(mechanicId: number, date: Date): Promise<any> {
        const model = {
            mechanicId: mechanicId,
            date: date.toDateString()
        }
        return this.dataProvider.GetAllwithHeaders<any>(Urls.GetTimeCodeDetails, model).toPromise();
    }

    async GetMechanicStampInOutDetails(mechanicId: number, date: Date): Promise<any> {
        const model = {
            mechanicId: mechanicId,
            date: date.toDateString()
        }
        return this.dataProvider.GetAllwithHeaders<any>(Urls.GetMechanicStampInOutDetails, model).toPromise();
    }
    UpdateMechanicStampOutDetails(model:any): Promise<any> {
        return this.dataProvider.Post<GenericResponse<any>>(Urls.UpdateMechanicStampOut, model).toPromise();
    }
    async GetCurrentWO(mechanicId: number): Promise<any> {
        return this.dataProvider.Get<any>(Urls.GetCurrentWO, mechanicId).toPromise();
    }

    async StartWorkOrderTimer(model: MechanicWorkOrderTimerRequestModel): Promise<GenericResponse<boolean>> {
        return this.dataProvider.Post<GenericResponse<any>>(Urls.StartWorkOrderTimer, model).toPromise();
    }

    async StopWorkOrderTimer(model: MechanicWorkOrderTimerRequestModel): Promise<GenericResponse<MechanicWorkOrderTimerRequestModel>> {
        return this.dataProvider.Put<GenericResponse<MechanicWorkOrderTimerRequestModel>>(Urls.StopWorkOrderTimer, model).toPromise();
    }

    async CheckMechanicTimeDetails(model: any): Promise<any> {
        return this.dataProvider.GetAllwithHeaders<any>(Urls.CheckMechanicTimeDetails, model).toPromise();
    }
    
    async StartJobTimer(model: MechanicJobTimerRequestModel): Promise<GenericResponse<boolean>> {
        return this.dataProvider.Post<GenericResponse<any>>(Urls.StartJobTimer, model).toPromise();
    }

    async StopJobTimer(model: MechanicJobTimerRequestModel): Promise<GenericResponse<MechanicJobTimerRequestModel>> {
        return this.dataProvider.Put<GenericResponse<MechanicJobTimerRequestModel>>(Urls.StopJobTimer, model).toPromise();
    }

    async GetJobsByWO(workOrderNo: string): Promise<JobsByWOResponseModel> {
        return this.dataProvider.Get<JobsByWOResponseModel>(Urls.GetJobsByWO, workOrderNo).toPromise();
    }

    async GetWOSummary(mechanicId: number, workOrderNo: string): Promise<any> {
        return this.dataProvider.Get<any>(Urls.GetWOSummary, mechanicId, workOrderNo).toPromise();
    }

    async GetWorkOrders(dealerId: string): Promise<GenericResponse<Array<WorkOrderModel>>> {
        return this.dataProvider.Get<GenericResponse<Array<WorkOrderModel>>>(Urls.GetWorkOrderList, dealerId).toPromise();
    }

    async GetWorkOrderDetails(mechanicId: number, workOrderNo: string): Promise<any> {
        return this.dataProvider.Get<any>(Urls.GetWorkOrderDetail, mechanicId, workOrderNo).toPromise();
    }
    async DeleteSummaryDetails(model:any): Promise<any> {
        return this.dataProvider.Post<GenericResponse<any>>(Urls.DeleteSummaryDetails, model).toPromise();
    }
    async EditSummaryDetails(model:any): Promise<any> {
        return this.dataProvider.Post<GenericResponse<any>>(Urls.EditSummaryDetails, model).toPromise();
    }
    async CheckTimerDetails(model:any): Promise<any> {
        return this.dataProvider.Post<GenericResponse<any>>(Urls.CheckTimerDetails, model).toPromise();
    }
    async EditClockingDetails(model:any): Promise<GenericResponse<number>> {
        return this.dataProvider.Post<GenericResponse<number>>(Urls.EditClockingDetails, model).toPromise();
    }
    async GetJobDetailByWO(jobId: number): Promise<JobsByWOResponseModel> {
        return this.dataProvider.Get<JobsByWOResponseModel>(Urls.GetJobDetailByWO, jobId).toPromise();
    }
    async StartJobDetailTimer(model: MechanicJobTimerRequestModel): Promise<GenericResponse<boolean>> {
        return this.dataProvider.Post<GenericResponse<any>>(Urls.StartJobDetailTimer, model).toPromise();
    }
    async StopJobDetailTimer(model: MechanicJobTimerRequestModel): Promise<GenericResponse<boolean>> {
        return this.dataProvider.Post<GenericResponse<any>>(Urls.StopJobDetailTimer, model).toPromise();
    }
}